import React, { useEffect, useState } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import LayerCombo from './LayerCombo';
import RegularButton from 'components/CustomButtons/Button';
import useLayerContext from 'contexts/layerContext';
import { Add, Remove } from '@material-ui/icons';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';

function TabPanel(props) {
  const { children, value, index } = props;
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && children}
    </div>
  );
}

function LayerDivitionTab(props) {
  const { disabled = false, customerRoutes, onCustomerRouteChange } = props;
  const { onAddDivition } = props;
  const { addPermission } = props;
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [addressDivitions, setAddressDivitions] = useState([]);

  const {
    divitions,
    selectedDivition,
    selectedLayer,
    setSelectedDivition,
    setSelectedLayer,
    excludedDivitions,
    setExcludedDivitions,
  } = useLayerContext();

  async function addDivition() {
    if (addressDivitions.map((ad) => ad.divition.id).includes(selectedDivition.id)) {
      return;
    }
    if (selectedLayer === undefined) return;
    if (onAddDivition !== undefined) {
      try {
        await onAddDivition(selectedDivition, selectedLayer);
      } catch {
        return;
      }
    }

    let newDivitions = [...addressDivitions];
    newDivitions.push({
      divition: selectedDivition,
      layer: selectedLayer,
    });

    setAddressDivitions(newDivitions);
    setExcludedDivitions((excluded) => {
      let newExcluded = [...excluded];
      newExcluded.push(selectedDivition.id);
      return newExcluded;
    });

    setTimeout(() => {
      setSelectedDivition(newDivitions[newDivitions.length - 1].divition);
      setSelectedLayer(newDivitions[newDivitions.length - 1].layer);
      setSelectedIndex(newDivitions.length - 1);
    });
  }

  // function removeDivition(addressDivition) {
  //   if (!addressDivitions.map((ad) => ad.divition.id).includes(selectedDivition.id)) {
  //     return;
  //   }

  //   let newDivitions = [...addressDivitions];
  //   let index = newDivitions.findIndex((ad) => ad.divition.id === addressDivition.divition.id);
  //   newDivitions.splice(index, 1);

  //   setAddressDivitions(newDivitions);
  //   setExcludedDivitions((excluded) => {
  //     let newExcluded = [...excluded];
  //     let index = newExcluded.findIndex((divitionId) => divitionId === addressDivition.divition.id);
  //     newExcluded.splice(index, 1);
  //     return newExcluded;
  //   });
  //   if (newDivitions.length > 0) {
  //     setTimeout(() => {
  //       setSelectedDivition(newDivitions[0].divition);
  //       setSelectedLayer(newDivitions[0].layer);
  //       setSelectedIndex(0);
  //     });
  //   }
  // }

  function selectIndex(_, index) {
    // Nueva divición
    if (addressDivitions.length === index) {
      if (onCustomerRouteChange !== undefined && customerRoutes !== undefined) {
        onCustomerRouteChange(undefined);
      }
      setSelectedIndex(index);
      let divition = divitions.find((divition) => !excludedDivitions.includes(divition.id));
      setSelectedDivition(divition);
      // TODO Setear divición que no este en la lista
      return;
    }

    // Capa ya existente
    setSelectedDivition(addressDivitions[index].divition);
    setSelectedIndex(index);
    if (onCustomerRouteChange !== undefined && customerRoutes !== undefined) {
      // Una dirección puede tener dos rutas en la misma división (ej. Mayorista y Minorista Nuevo):
      // además de la división se compara la capa y la ruta de la pestaña.
      let tab = addressDivitions[index];
      let cr =
        customerRoutes.find(
          (cr) =>
            cr.route !== null &&
            cr.divition.id === tab.divition.id &&
            Number(cr.route.base_layer_id) === Number(tab.base_layer_id) &&
            Number(cr.route.id) === Number(tab.base_route_id),
        ) || customerRoutes.find((cr) => cr.divition.id === tab.divition.id);
      onCustomerRouteChange(cr);
      setTimeout(() => {
        if (cr?.route) setSelectedLayer(cr.route.layer);
      });
    }else{
      setSelectedLayer(addressDivitions[index].layer);
    }
  }

  // AL cambiar el listado de ClienteRuta
  useEffect(() => {
    if (customerRoutes === undefined || customerRoutes.length === 0) return;
    
    let addressDivitions = customerRoutes
      .filter((cr) => cr.route !== null)
      .map((cr) => ({
        divition: cr.divition,
        layer: cr.route.layer,
        // Capa y ruta del cliente-ruta de esta pestaña: no cambian al elegir otra capa en el combo
        base_layer_id: cr.route.base_layer_id,
        base_route_id: cr.route.id,
      }));
    let excluded = customerRoutes
      .filter((cr) => cr.route !== null)
      .map((cr) => cr.divition.id);

    setAddressDivitions(addressDivitions);
    setExcludedDivitions(excluded);
  }, [customerRoutes]);

  return (
    <div>
      <AppBar position="static">
        <div style={{ display: 'flex' }}>
          <div style={{ flex: 1 }}>
            <Tabs value={selectedIndex} onChange={selectIndex}>
              {addressDivitions.map((addressDivition, index) => {
                return (
                  <Tab
                    label={addressDivition.divition.name}
                    key={`${addressDivition.divition.id}-${index}`}
                    disabled={disabled}
                  />
                );
              })}
              {(divitions.length + 1) !== addressDivitions.length && <Tab label="Nueva divición" />}
            </Tabs>
          </div>
          {(divitions.length + 1) !== addressDivitions.length && (
            <AllowedGuard permission={addPermission}>
              <RegularButton
                justIcon
                color="success"
                onClick={addDivition}
                disabled={
                  disabled ||
                  (selectedIndex !== addressDivitions.length &&
                    (selectedDivition === undefined || selectedLayer === undefined))
                }
              >
                <Add />
              </RegularButton>
            </AllowedGuard>
          )}
        </div>
      </AppBar>
      {addressDivitions.map((ad, index) => {
        return (
          <TabPanel value={selectedIndex} index={index} key={`${ad.divition.id}-${index}`}>
            <div style={{ display: 'flex' }}>
              <div style={{ flex: 1 }}>
                <LayerCombo
                  ignoreExcluded
                  lockDivition
                  disabled={disabled}
                  onChange={(_, item) => {
                    // La capa elegida es de esta pestaña (por posición): puede haber dos con la misma división
                    setAddressDivitions((addressDivitions) => {
                      if (addressDivitions[index] === undefined) return addressDivitions;
                      let newDivitions = [...addressDivitions];
                      newDivitions[index] = { ...newDivitions[index], layer: item };
                      return newDivitions;
                    });
                  }}
                />
              </div>
              {/* <RegularButton justIcon round color="danger" onClick={() => removeDivition(ad)}>
                <Remove />
              </RegularButton> */}
            </div>
          </TabPanel>
        );
      })}

      {(divitions.length + 1) !== addressDivitions.length && (
        <TabPanel value={selectedIndex} index={addressDivitions.length} key={'ad'}>
          <div style={{ display: 'flex' }}>
            <div style={{ flex: 1 }}>
              <LayerCombo disabled={disabled} />
            </div>
          </div>
        </TabPanel>
      )}
    </div>
  );
}

export default LayerDivitionTab;
